import styled from "@emotion/styled";
import { SiteContainer, H1 } from "atoms";
import { Head } from "features/misc";
import { ProjectForm } from "features/reviewable";
import sparklesURL from "assets/images/sparkles.svg";

function CreateProject() {
  return (
    <SiteContainer as="main">
      <Head title="Create Project" />

      <SH1>
        <img src={sparklesURL} alt="" aira-hidden="true" /> Create
        New&nbsp;Project <img src={sparklesURL} alt="" aira-hidden="true" />
      </SH1>
      <ProjectForm />
    </SiteContainer>
  );
}

const SH1 = styled(H1)({
  alignItems: "center",
  display: "flex",
  gap: 10,
  justifyContent: "center",
  marginBottom: "1.25em",
  textAlign: "center",
  img: {
    width: "1.5em",
    height: "auto",
  },
});
export { CreateProject };
